// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from "./store";
/* 路由 */
import router from './router'

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'
// 引入字体
import './assets/fonts/font.css' 
/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'
import less from 'less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import * as echarts from 'echarts';
// Vue.prototype.$echarts = echarts 
/* 头部组件 */
import Header from './components/Header'

/* 尾部组件 */
import Footer from './components/Footer'

/* 回到顶部 */
import GoTop from './components/GoTop'
/* Loading */
import Loading from './components/animation'
// 引入多语言
import i18n from './i18n';

Vue.use(ElementUI);
Vue.use(less)
Vue.component(Header.name,Header)
Vue.component(Footer.name,Footer)
Vue.component(GoTop.name,GoTop)
Vue.component(Loading.name,Loading)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    // if(to.meta.title){
    //   document.title = to.meta.title
    // }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js